// extracted by mini-css-extract-plugin
export default {"mainContainer":"notificationstempletes_mainContainer__u-cnU","tags":"notificationstempletes_tags__zG4KT"};